export class ApiEndPointsModuleMaster {

     // Summary
  // Call api to add module
  addModule = 'api/Module/AddModule';

  getModule = 'api/Module/GetModuleList';

  deleteModule = 'api/Module/DeleteModule';

  updateModule = 'api/Module/UpdateModule'
}
